import { render, staticRenderFns } from "./MserviceadvisorCreate.vue?vue&type=template&id=47c98f0a&scoped=true"
import script from "./MserviceadvisorCreate.vue?vue&type=script&lang=js"
export * from "./MserviceadvisorCreate.vue?vue&type=script&lang=js"
import style0 from "./MserviceadvisorCreate.vue?vue&type=style&index=0&id=47c98f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c98f0a",
  null
  
)

export default component.exports